import React, { useState } from "react";
import { ADMIN_BASE, getStoredToken } from "./api";
import { toast } from "sonner";
import { Download, FileText, FileSpreadsheet, FileType2, ChevronDown, Loader2 } from "lucide-react";

const FORMATS = [
  { key: "csv", label: "CSV", icon: FileSpreadsheet },
  { key: "xlsx", label: "Excel", icon: FileSpreadsheet },
  { key: "pdf", label: "PDF", icon: FileType2 },
];

export default function ExportMenu({ entity, testidPrefix = "export", label = "Export" }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState("");

  const handle = async (fmt) => {
    setOpen(false);
    setBusy(fmt);
    try {
      const token = getStoredToken();
      const res = await fetch(`${ADMIN_BASE}/export/${entity}.${fmt}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        credentials: "include",
      });
      if (!res.ok) throw new Error(`Export failed (${res.status})`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${entity}.${fmt}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 4000);
      toast.success(`${entity}.${fmt} downloaded`);
    } catch (e) {
      toast.error(e?.message || "Export failed");
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="relative" data-testid={`${testidPrefix}-menu`}>
      <button
        type="button"
        className="ax-btn"
        onClick={() => setOpen((v) => !v)}
        data-testid={`${testidPrefix}-button`}
      >
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
        {busy ? `Exporting ${busy.toUpperCase()}…` : label}
        <ChevronDown className="w-3 h-3 opacity-60" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div
            className="absolute right-0 top-full mt-1 w-44 ax-glass z-40 p-1"
            style={{ borderRadius: 12 }}
          >
            {FORMATS.map(({ key, label: l, icon: Icon }) => (
              <button
                key={key}
                type="button"
                className="w-full text-left px-3 py-2 rounded-md text-sm flex items-center gap-2 hover:bg-white/[0.04]"
                onClick={() => handle(key)}
                data-testid={`${testidPrefix}-${key}`}
              >
                <Icon className="w-3.5 h-3.5" style={{ color: "var(--ax-gold)" }} />
                <span>{l}</span>
                <span className="ml-auto ax-mono text-[10px]" style={{ color: "var(--ax-text-muted)" }}>
                  .{key}
                </span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
